import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

interface SwConfirmDialogData {
  title: string | undefined;
  prompt: string;
  cancelButton: string | undefined;
  actionButton: string;
}

@Component({
  selector: 'sw-confirm-dialog',
  templateUrl: 'sw-confirm-dialog.html',
  styleUrls: ['../../scss/dialog-base.scss'],
})
export class SwConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SwConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SwConfirmDialogData
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
